export const PAGE_404_IMAGES = {
  DINOSAUR: '/404_page/belong_404_city_general_01.svg',
};
